export default __webpack_public_path__ + "static/media/testing.6a7a50b4.svg";